<!-- DeepSea Positions Pg -->
<template>

  <!-- Scam Warning -->
  <div class="scam-warning-wrapper">
    <div class="scam-warning">
      <div class="scam-warning-title">Scam <span style="color: #FDDC03">Alert</span><br><span style="color: #FDDC03">Be
          Aware</span> of Fake
        Recruiters
      </div>
      <div class="scam-warning-copy">SeeScan, Inc. has become aware that someone posing as a recruiter from
        "seescancareershub.com" is reaching
        out to job seekers. Please be aware that this domain, "seescancareershub.com," is not affiliated with our
        company domain "seescan.com" in any way. If you are interested in applying for a job at SeeScan, Inc., the
        official website is https://careers.seescan.com. For your safety and to ensure you are communicating with
        SeeScan's recruiters, please verify the domain of the email address. Official communications from SeeScan,
        Inc.
        will only come from email addresses ending in "@seescan.com."<br><br>Thank you for your vigilance and
        cooperation.
      </div>
    </div>
  </div>

  <!-- Intro - Welcome -->
  <div class="intro">
    <h2>Welcome</h2>
    <div class="intro-line"></div>
    <br>
    <p>
      Welcome to DeepSea's job opportunities portal. We’re committed to creating
      a collaborative and inspiring culture for everyone who works here. All of
      our currently open positions are listed below by category and include
      positions at our DeepSea and SeeScan divisions. Select a position to view
      more information and to apply.
    </p>
    <br>
    <p>Visit our SeeScan careers page to view additional job opportunities.</p>
  </div>

  <!-- SeeScan Careers -->
  <div class="seescan-careers">
    <router-link :to="{
      name: 'positions'
    }" @click="setFavicon" class="seescan-careers-link">
      <div class="seescan-careers-content">
        <div>SeeScan Careers</div>
        <div>
          <button class="seescan-careers-btn">
            <p>View Jobs</p>
            <BaseIcon class="arrows-icon" :iconName="arrows" :width="24" :height="24" iconColor="#5cba47">
              <IconArrows />
            </BaseIcon>
          </button>
        </div>
      </div>
    </router-link>
  </div>

  <!-- Who We Hire -->
  <div id="who-we-hire" class="who">
    <h2>Who We Hire</h2>
    <br>
    <p>No matter what position we’re hiring for, we’re looking for people who are:</p>
    <br>
    <div class="who-grid">
      <div class="who-r-1">
        <p>
          <span class="icon-title">
            <BaseIcon class="innovation-icon" :iconName="innovation" :width="40" :height="40" iconColor="#5cba47">
              <IconInnovation />
            </BaseIcon>
            <strong>In it for work that matters –</strong>
          </span>
          <br />Our goal is to make
          innovative technology that makes the world better. When our employees
          believe in our mission and express a genuine desire to be part of what
          we do, we achieve our best work. We want people who will view being here
          as more than “just another job.”
        </p>
        <p>
          <span class="icon-title">
            <BaseIcon class="community-icon" :iconName="community" :width="40" :height="40">
              <IconCommunity />
            </BaseIcon>
            <strong>Community members –</strong>
          </span>
          <br />SeeScan is a people-focused
          organization, and at the heart of SeeScan is our community. We’re in it
          for the long run. We want people who will be part of the larger
          community and stay with us for the long run, too.
        </p>
        <p>
          <span class="icon-title">
            <BaseIcon class="values-icon" :iconName="values" :width="40" :height="40">
              <IconValues />
            </BaseIcon>
            <strong>Aligned with our values –</strong>
          </span>
          <br />Fairness, integrity,
          respect, transparency. These are the values we live at SeeScan, and our
          candidates should have these, too.
        </p>
      </div>
      <div class="who-r-2">
        <p>
          <span class="icon-title">
            <BaseIcon class="lightbulb-icon" :iconName="lightbulb" :width="40" :height="40">
              <IconLightbulb />
            </BaseIcon>
            <strong>Authentically curious, critical thinker –</strong>
          </span>
          <br />SeeScan
          is a learning organization. In fact, continual learning is one of our
          core values. Our commitment to continuously improving as an organization
          means we hire people who demonstrate both the desire and capability to
          continually learn and grow themselves. This translates to hiring people
          who are naturally curious at heart, who not only do their jobs well but
          are able to imagine and do better individually and across the
          organization.
        </p>
        <p>
          <span class="icon-title">
            <BaseIcon class="goal-icon" :iconName="goal" :width="40" :height="40">
              <IconGoal />
            </BaseIcon>
            <strong>Independently driven with a “we” mentality –</strong>
          </span>
          <br />At
          SeeScan, we have an open, collaborative environment instead of rigid
          hierarchies. This translates to a lot of autonomy for many of our
          employees. But regardless of the degree of autonomy a single employee
          has, what ties all of us together is being internally driven to succeed.
          At the same time, while our employees are motivated to do their best at
          their own work, they are always thinking of the wider team and
          organization.
        </p>
      </div>
    </div>
    <br>
  </div>

  <!-- Cover Letter -->
  <div id="cover-letter" class="cover-letter">
    <div class="cover-letter-img"></div>
    <div class="cover-letter-copy">
      <h2 class="cover-letter-title">The Importance of the Cover Letter</h2>
      <div class="cover-letter-line"></div>
      <p>
        At DeepSea, our focus is on hiring the person, not a list of
        qualifications. Hiring the person—you!—starts with the cover
        letter.
      </p>
      <br>
      <p>
        We require all of our candidates to submit a thoughtful cover letter in
        addition to their resume. The cover letter is our first introduction to
        you as a person. We are interested in knowing more about you, why you want
        to be part of the DeepSea team, and how you think your skills and
        experiences will positively contribute to our organization.
      </p>
      <br>
      <p>
        The cover letter is so important to us that only candidates who submit a
        cover letter with their application will be considered for employment at
        DeepSea.
      </p>
      <br>
      <p>
        The cover letters that we are looking for:
      </p>
      <ul>
        <li>Express a genuine interest in working here</li>
        <li>
          Highlight your unique skills and background, and describe how they will help you succeed in the role based on
          what the job description calls for
        </li>
        <li>
          Remain on message and free of inconsistencies with your resume or application
        </li>
        <li>
          Are generally formatted well
        </li>
      </ul>
      <br>
      <p>
        If your cover letter is a match for what we’re looking for, we will reach out to you for a phone interview. You
        can read more about our 3-step hiring process on our <a class="text-link"
          href="https://www.deepsea.com/life-at-deepsea/" target="_blank" rel="noopener noreferrer">
          <strong>Life at DeepSea</strong>
        </a> page.
      </p>
    </div>

  </div>

  <!-- Current Openings -->
  <div class="current-openings">
    <h2>Current Openings</h2>
    <p v-if="pos_loading">Loading...</p>
    <div class="job-wrap">
      <div class="text-Gradientbuttons">
        <TextButton :hoverColor="'#ffda00'" v-on:click="showAll()" v-show="collapsed">View All</TextButton>
        <TextButton :hoverColor="'#ffda00'" v-on:click="hideAll()" v-show="!collapsed">Hide All</TextButton>
      </div>
      <details v-for="(key, val) in positions" v-bind:key="val">
        <summary>{{ val }} ({{ key.count }})</summary>
        <ul>
          <li v-for="position in key.positions" :key="position">
            <router-link :to="{
              name: 'deepsea-position-description',
              params: { id: position.id, from: from },
            }">{{ position.title }}
            </router-link>
            <hr />
          </li>
        </ul>
      </details>
    </div>
    <p v-if="pos_error">{{ pos_error }}</p>
    <!--
    <router-link :to="{ name:'deepsea-applicant-form', params:{ id: 1 }}">
      <Button id="apply-now" deepsea="true">Apply Now</Button>
    </router-link>
    <br />
    -->

    <br />
    <br />
    <!-- <a href="#cover-letter" target="_self" rel="noopener noreferrer">
      <TextButton :deepsea="true" :hoverColor="'#ffda00'">The Importance of the Cover Letter</TextButton>
      <Button :deepsea="true"
        >The Importance of the Cover Letter</Button
      >
    </a> -->
  </div>
</template>

<script>
import axios from 'axios'
// import BackgroundHalfCircle from '@/components/backgrounds/BackgroundHalfCircle.vue'
// import BaseBackground from '@/components/global/BaseBackground.vue'
import BaseIcon from '@/components/global/BaseIcon.vue'
// import Button from '@/components/buttons/Button.vue'
// import IconSwarm from '@/components/icons/IconSwarm.vue'
import TextButton from '@/components/buttons/TextButton.vue'
import IconArrows from '../components/icons/IconArrows.vue'
import IconInnovation from '../components/icons/IconInnovation.vue'
import IconCommunity from '../components/icons/IconCommunity.vue'
import IconGoal from '../components/icons/IconGoal.vue'
import IconValues from '../components/icons/IconValues.vue'
import IconLightbulb from '../components/icons/IconLightbulb.vue'
// import Separator from '@/components/Separator.vue'
// import LearnMore from '@/components/LearnMore.vue'

let positionsUrl =
  'https://careers-api.seescan.com/api/v1/positions/division/deepsea'
// let positionsUrl = 'http://localhost:3000/api/v1/positions'
const posRequest = axios.get(positionsUrl)

export default {
  name: 'Positions',
  components: {
    IconArrows,
    IconCommunity,
    IconGoal,
    IconInnovation,
    IconLightbulb,
    IconValues,
    // BackgroundHalfCircle,
    // BaseBackground,
    BaseIcon,
    // Button,
    // IconSwarm,
    TextButton,
    // Separator,
    // LearnMore,
  },
  data() {
    return {
      pos_loading: false,
      positions: null,
      pos_error: '',
      collapsed: true,
      from: ''
    }
  },
  created() {
    this.from = this.$route.query.source || document.referrer || '';
    axios
      .all([posRequest])
      .then(
        axios.spread((...responses) => {
          const responsePos = responses[0].data
          let categories = {}

          for (let i = 0; i < responsePos.data.positions.results.length; i++) {
            let cat = responsePos.data.positions.results[i].category
            let position = {
              id: responsePos.data.positions.results[i].id,
              title: responsePos.data.positions.results[i].title,
              categoryId: responsePos.data.positions.results[i].categoryId
            }

            if (Object.prototype.hasOwnProperty.call(categories, cat)) {
              categories[cat].positions.push(position)
              categories[cat].count++
              if (categories[cat].count > 1) {
                categories[cat].label = 'Jobs'
              }
            } else {
              categories[cat] = {
                count: 1,
                label: 'Job',
                positions: [],
              }
              categories[cat]['count'] = 1
              categories[cat].positions.push(position)
            }
          }

          this.positions = categories
        })
      )
      .catch((errors) => {
        console.error(errors)
      })
  },
  methods: {
    setFavicon(to) {
      const favicon = document.querySelector("[rel='icon']")
      favicon.setAttribute('href', to.$route.meta.icon)
    },
    showAll() {
      // Fetch all details elements
      const details = document.querySelectorAll('details')

      // Open all the details
      details.forEach((detail) => {
        detail.open = true
      })

      this.collapsed = false
    },
    hideAll() {
      // Fetch all details elements
      const details = document.querySelectorAll('details')

      // Close all the details
      details.forEach((detail) => {
        detail.open = false
      })

      this.collapsed = true
    },
  },
}
</script>

<style scoped>
/* Mobile first default */
h2 {
  color: #192b6d;
}

h2.white {
  color: white;
  padding-top: 8%;
}

ul li {
  list-style: none;
}

a.text-link {
  color: black;
  font-size: 1em;
}

/* Scam Warning */
div.scam-warning-wrapper {
  display: flex;
  justify-content: center;
  background-color: #0956A1;
  color: white;
  width: 100%;
}

div.scam-warning {
  gap: 24px;
  padding: 96px 8%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: left;
}

div.scam-warning-title {
  flex: 1 0 50%;
  font-size: 32px;
  font-weight: 600;
}

div.scam-warning-copy {
  flex: 1 0 50%;
  font-size: 16px;
  max-width: 60ch;
}

/* Intro - Welcome */
.intro {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  padding: 96px 8%;
}

.intro-line {
  height: 1px;
  width: 100%;
  background-color: #0956A1;
}

.intro h2 {
  text-transform: capitalize;
}

.intro h2,
.intro p {
  text-align: left;
}

/* SeeScan Careers */
.seescan-careers {
  padding: 24px 8%;
  color: white;
  background: linear-gradient(90deg, #0956A1 0%, #39D52D 100%);
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.seescan-careers-link {
  text-decoration: none;
  width: 100%;
  max-width: 1130px;
  display: block;
  color: white;
}

.seescan-careers-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  /* max-width: 1130px; */
  transition: all 0.25s ease-in-out;
}

.seescan-careers .seescan-careers-btn {
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
}

.seescan-careers-link:hover .seescan-careers-content {
  color: #fddc03;
  font-weight: bolder;
  font-size: large;
  text-decoration: none;
}

.seescan-careers a,
.seescan-careers-content a {
  text-decoration: none;
}

/* Who We Hire */
.who {
  padding: 96px 8%;
  background-image: url('../assets/images/who-we-hire-bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}

.who h2 {
  color: white;
  text-transform: capitalize;
  padding: 0;
}

.who .who-grid p {
  text-align: left;
  padding: 20px;
  background-color: #192B6C;
  /* display: flex;
  flex-direction: column; */
}

.who .who-grid div p .icon-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* .who-grid,
.who-r-1,
.who-r-2 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
} */

.who-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
}

.who-r-1,
.who-r-2 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-items: stretch;
}

/* .who-r-1 p,
.who-r-2 p {
  flex: 1 1 0;
  min-height: 0;
} */

/* Cover Letter */
.cover-letter {
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  justify-content: center;
  margin-bottom: 48px;
  padding: 96px 8%;
  gap: 48px;
  max-width: 1360px;
  margin: 0 auto;
}

.cover-letter-img {
  flex: 1;
  background-image: url(../assets/images/deepsea-cover-letter-img.png);
  background-size: cover;
  background-position: 50% 50%;
  width: 100%;
  height: auto;
  min-height: 400px;
  border-radius: 100px 0;
}

.cover-letter-copy {
  flex: 1;
}

.cover-letter-title {
  text-transform: capitalize;
  color: #192B6C;
  text-align: left;
  padding: 0;
}

.cover-letter-line {
  height: 1px;
  background-color: #0956A1;
  width: 100%;
  margin: 16px 0 24px 0;
}

.cover-letter p {
  text-align: left;
}

.cover-letter-copy ul {
  margin: 1em 2em;
}

.cover-letter ul li {
  text-align: left;
  list-style-position: outside;
  list-style-type: square;
  margin-bottom: 4px;
}

/* Current Openings */
.current-openings {
  background-color: #e8e8e8;
  padding: 96px 8%;
}

div.job-wrap {
  width: 100%;
  text-align: left;
  max-width: 600px;
  margin: 0 auto;
  padding: 1em;
}

div.job-wrap div.text-Gradientbuttons {
  display: flex;
  flex: row nowrap;
  justify-content: center;
}

details {
  margin: 0 auto;
  cursor: pointer;
  padding: 1em;
  background: #f0f0f0;
  max-width: 800px;
  font-family: 'Montserrat', sans-serif;
  font-size: 1.2em;
  font-weight: normal;
  color: #464545;
  border-radius: 16px;
  border: none;
  margin-top: 16px;
  /* margin-top: 48px; */
  box-shadow: inset 0px -11px 8px -10px #ccc;
}

details summary::-webkit-details-marker {
  margin-top: 10px;
  color: #ffda00;
  float: right;
}

details:hover summary::-webkit-details-marker:hover {
  color: #ffda00;
}

details summary {
  outline: none;
  /* font-size: 22px; */
  color: #444444;
}

details summary>* {
  display: inline;
}

details ul {
  margin: 0;
  padding: 1em;
  text-align: left;
}

details ul li:last-child>hr {
  display: none;
}

details ul li:last-child {
  padding-bottom: 0;
  margin-bottom: 0;
}

details ul li {
  margin: 0;
  padding: 0;
}

details ul li a {
  color: #666666;
}

details summary ul li a:hover {
  text-decoration: none;
}

@media screen and (min-width: 615px) {

  /* Scam Warning */
  div.scam-warning {
    padding: 50px 100px;
    flex-wrap: wrap;
    justify-content: left;
  }

  /* Intro - Welcome */
  .intro {
    max-width: 1360px;
    margin: 0 auto;
  }

  /* Who We Hire */
  .who {
    padding: 96px 100px;
    flex-wrap: wrap;
  }

  /* Cover Letter */
  .cover-letter {
    flex-direction: column-reverse;
    gap: 48px;
  }

  .cover-letter-img {
    border-radius: 150px 0;
  }

  .cover-letter-copy p,
  .cover-letter-copy ul li {
    max-width: 60ch;
  }

  h2.white {
    padding-top: 4%;
  }

  .hiring-process {
    position: relative;
    z-index: -99;
    top: 50px;
    padding-bottom: 50px;
  }
}

@media screen and (min-width: 850px) {

  /* Who We Are */
  .who-r-1,
  .who-r-2 {
    flex-direction: row;
  }

  .who-r-1 p,
  .who-r-2 p {
    flex: 1 1 0;
    min-height: 0;
  }

  .who .who-grid p {
    display: flex;
    flex-direction: column;
  }

  /* Cover Letter */
  .cover-letter {
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 96px 8%;
  }

  .cover-letter-copy {
    max-width: 60ch;
  }

}

@media screen and (min-width: 1200px) {

  /*Scam Warning */
  div.scam-warning {
    flex-wrap: nowrap;
  }

  /* Who We Hire */
  .who {
    padding: 96px 200px;
  }

  div.job-wrap div.text-Gradientbuttons {
    justify-content: flex-end;
  }
}

@media screen and (min-width: 1650px) {
  .cover-letter {
    padding: 96px 0px;
  }
}

@media screen and (min-width: 1950px) {

  /* Intro - Welcome */
  .intro {
    padding: 96px 48px;
  }

  /* Who We Hire */
  .who .who-grid {
    max-width: 1360px;
    margin: 0 auto;
  }



}
</style>
